var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCommentIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 0.75V9H4.2832L1.5 11.7832V9H0V0.75H12ZM11.25 1.5H0.75V8.25H2.25V9.9668L3.9668 8.25H11.25V1.5ZM7.5 5.25H6.75V3.75H8.25V5.25C8.25 5.35547 8.23047 5.45312 8.19141 5.54297C8.15234 5.63281 8.09766 5.71289 8.02734 5.7832C7.96094 5.84961 7.88281 5.90234 7.79297 5.94141C7.70312 5.98047 7.60547 6 7.5 6V5.25ZM4.5 5.25H3.75V3.75H5.25V5.25C5.25 5.35547 5.23047 5.45312 5.19141 5.54297C5.15234 5.63281 5.09766 5.71289 5.02734 5.7832C4.96094 5.84961 4.88281 5.90234 4.79297 5.94141C4.70312 5.98047 4.60547 6 4.5 6V5.25Z",
    fill: "#323130"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommentIcon);
export default __webpack_public_path__ + "static/media/CommentIcon.0f3376dce641a74525060936fbe08813.svg";
export { ForwardRef as ReactComponent };